
import * as $ from 'jquery';

import * as AllyConfig from 'src/shared/rest/Config';

/**
 * The Moodle LMS
 *
 * @class
 * @implements {ExampleInterface}
 */
export function MoodleRestApi() {}

/**
 * @see ExampleInterface.prototype.sign
 */
MoodleRestApi.prototype.sign = function(method, path, parameters, callback) {
    var data = {
        'url': AllyConfig.baseUrl() + path,
        'headers': {
            'Authorization': `Bearer ${ this._getJwtToken()}`
        },
        'parameters': parameters
    };
    return callback(null, data);
};

/**
 * @see ExampleInterface.prototype.http
 */
MoodleRestApi.prototype.http = function(method, path, parameters, opts, callback) {
    opts = opts || {};

    var req = {
        'url': AllyConfig.baseUrl() + path,
        'type': method,
        'crossDomain': true,
        'xhrFields': {
            'withCredentials': false
        },
        'data': parameters,
        'success': function(data) {
            return callback(null, data);
        },
        'error': function(xhr, code) {
            return callback({ 'code': code, 'msg': xhr.responseText });
        }
    };
    req.headers = opts.headers || {};
    req.headers.Authorization = `Bearer ${ this._getJwtToken()}`;

    if (opts.contentType) {
        req.contentType = opts.contentType;
    }

    $.ajax(req);
};

/**
 * @see ExampleInterface.prototype.getDownloadUrl
 */
MoodleRestApi.prototype.getDownloadUrl = function(fileId, callback) {
    // At this point it's unclear whether a file can be downloaded when only the fileId is known
    return callback({ 'code': 501, 'msg': 'Moodle does not support direct downloads' });
};

/**
 * Get a JWT token that can authenticate the current user with Ally
 *
 * @return {String}    A JWT token that can authorize the user with Ally, provided by Moodle
 */
MoodleRestApi.prototype._getJwtToken = function() {
    return window['require'].s.contexts._.require('filter_ally/ally').token();
};
